var listServiceObj =
{
    // Owner

    getLeasingCompanies: function () {

        // TO DO: cache
        return axios.get('api/List/leasingCompanies');
    },

    getFieldsOfActivity: function () {
        return axios.get('api/List/fieldsOfActivity');
    },

    getDriverLicenceYears: function () {
        var result = [];
        var currentYear = new Date().getFullYear();

        for (var i = currentYear; i >= 1950; i--)
            result.push(i);

        return result;
    },

    // Vehicle

    getRegisterTypes: function () {
        return [
            { Code: 0, Name: 'Inmatriculat' },
            { Code: 1, Name: 'Inregistrat' },
            { Code: 2, Name: 'In vederea inmatricularii' },
            { Code: 3, Name: 'In vederea inregistrarii' }
        ];
    },

    getVehicleCategories: function () {
        return [
            {
                Code: 1, Name: 'Autoturism / Automobil mixt', SubCategories: [
                    { Code: 0, Name: '' },
                    { Code: 2, Name: 'Automobil mixt' },
                    { Code: 1, Name: 'Autoturism' },
                    { Code: 3, Name: 'Autoturism de teren' }
                ]
            },
            {
                Code: 2, Name: 'Autosanitara / Autorulota', SubCategories: [
                    { Code: 0, Name: '' },
                    { Code: 5, Name: 'Autorulota' },
                    { Code: 4, Name: 'Autosanitara' }
                ]
            },
            {
                Code: 3, Name: 'Autovehicul transport persoane', SubCategories: [
                    { Code: 0, Name: '' },
                    { Code: 7, Name: 'Autobuz' },
                    { Code: 9, Name: 'Autobuz articulat' },
                    { Code: 10, Name: 'Autobuz special' },
                    { Code: 8, Name: 'Autocar' },
                    { Code: 6, Name: 'Microbuz' },
                    { Code: 11, Name: 'Tramvai' },
                    { Code: 12, Name: 'Troleibuz' }
                ]
            },
            {
                Code: 4, Name: 'Autovehicul transport marfa', SubCategories: [
                    { Code: 0, Name: '' },
                    { Code: 16, Name: 'Autobasculanta' },
                    { Code: 23, Name: 'Autobetoniera' },
                    { Code: 19, Name: 'Autocamion' },
                    { Code: 24, Name: 'Autocisterna' },
                    { Code: 22, Name: 'Autoexcavator' },
                    { Code: 14, Name: 'Autofurgon' },
                    { Code: 25, Name: 'Autogreder' },
                    { Code: 26, Name: 'Autoincarcator' },
                    { Code: 27, Name: 'Automacara' },
                    { Code: 20, Name: 'Autospeciala' },
                    { Code: 21, Name: 'Autospecializata' },
                    { Code: 13, Name: 'Autoutilitara' },
                    { Code: 17, Name: 'Basculanta' },
                    { Code: 28, Name: 'Buldoexcavator' },
                    { Code: 18, Name: 'Camion' },
                    { Code: 15, Name: 'Furgon' }
                ]
            },
            {
                Code: 5, Name: 'Autotractor', SubCategories: [
                    { Code: 0, Name: '' },
                    { Code: 29, Name: 'Autotractor' },
                    { Code: 30, Name: 'Autotractor cu sa' },
                    { Code: 31, Name: 'Cap tractor' }
                ]
            },
            {
                Code: 6, Name: 'Tractor', SubCategories: [
                    { Code: 0, Name: '' },
                    { Code: 41, Name: 'Tractor agricol' },
                    { Code: 32, Name: 'Tractor rutier' }
                ]
            },
            {
                Code: 7, Name: 'Motocicleta / Moped / Atas / ATV', SubCategories: [
                    { Code: 0, Name: '' },
                    { Code: 36, Name: 'ATV' },
                    { Code: 34, Name: 'Moped' },
                    { Code: 33, Name: 'Motocicleta' },
                    { Code: 35, Name: 'Scuter' }
                ]
            },
            {
                Code: 8, Name: 'Remorca / Semiremorca / Rulota', SubCategories: [
                    { Code: 0, Name: '' },
                    { Code: 37, Name: 'Remorca' },
                    { Code: 39, Name: 'Rulota' },
                    { Code: 38, Name: 'Semiremorca' }
                ]
            },
            {
                Code: 9, Name: 'Utilaje', SubCategories: [
                    { Code: 0, Name: '' },
                    { Code: 40, Name: 'Utilaje' }
                ]
            }
        ];
    },

    getUsageTypes: function () {
        return [
            { Code: 'personal', Name: 'In interes personal' },
            { Code: 'transport international', Name: 'Transport international' },
            { Code: 'taxi', Name: 'Taxi' },
            { Code: 'inchiriere', Name: 'Rent-a-car' },
            { Code: 'scoala de soferi', Name: 'Scoala de soferi' },
            { Code: 'paza si protectie', Name: 'Paza si protectie' },
            { Code: 'curierat', Name: 'Curierat' },
            { Code: 'institutie publica', Name: 'Institutie publica' },
            { Code: 'constructii', Name: 'Constructii' },
            { Code: 'distributie', Name: 'Distributie' },
            { Code: 'transport marfa', Name: 'Transport marfa' },
            { Code: 'transport produse farmaceutice', Name: 'Transport produse farmaceutice' },
            { Code: 'masina de serviciu', Name: 'Masina de serviciu' },
        ];
        /*
        /// <remarks/>
        distributie,

        /// <remarks/>
        [System.Xml.Serialization.SoapEnumAttribute("transport marfa")]
        transportmarfa,
        */
    },

    getFuelTypes: function () {
        return [
            { Code: 'benzina', Name: 'benzina' },
            { Code: 'motorina', Name: 'motorina' },
            { Code: 'electric', Name: 'electric' },
            { Code: 'benzinasigpl', Name: 'benzina si gpl' },
            { Code: 'benzinasialcool', Name: 'benzina si alcool' },
            { Code: 'altul', Name: 'altul' },
            { Code: 'fara', Name: 'fara' }
        ];
    },

    getVehicleBrands: function () {
        return [
            { Code: 'acura', Name: 'Acura' },
            { Code: 'agados', Name: 'AGADOS' },
            { Code: 'agrogep', Name: 'AGROGEP' },
            { Code: 'Romeo,alfa romeo', Name: 'Alfa Romeo' },
            { Code: 'altele', Name: 'ALTELE' },
            { Code: 'anssems', Name: 'ANSSEMS' },
            { Code: 'aprilia', Name: 'Aprilia' },
            { Code: 'aro', Name: 'Aro' },
            { Code: 'asia motors', Name: 'Asia Motors' },
            { Code: 'aston martin', Name: 'Aston Martin' },
            { Code: 'astra', Name: 'ASTRA' },
            { Code: 'audi', Name: 'Audi' },
            { Code: 'austin', Name: 'Austin' },
            { Code: 'austin healey', Name: 'Austin Healey' },
            { Code: 'bentley', Name: 'Bentley' },
            { Code: 'berger', Name: 'BERGER' },
            { Code: 'blumhardt', Name: 'BLUMHARDT' },
            { Code: 'blyss', Name: 'BLYSS' },
            { Code: 'bmw', Name: 'BMW' },
            { Code: 'bombardier', Name: 'BOMBARDIER' },
            { Code: 'borgward', Name: 'Borgward' },
            { Code: 'boro', Name: 'Boro' },
            { Code: 'brantner', Name: 'BRANTNER' },
            { Code: 'brenderup', Name: 'BRENDERUP' },
            { Code: 'brilliance', Name: 'Brilliance' },
            { Code: 'buburuza', Name: 'buburuza' },
            { Code: 'bugatti', Name: 'Bugatti' },
            { Code: 'buick', Name: 'Buick' },
            { Code: 'cadillac', Name: 'Cadillac' },
            { Code: 'cardi', Name: 'CARDI' },
            { Code: 'caterham', Name: 'Caterham' },
            { Code: 'chevrolet', Name: 'Chevrolet' },
            { Code: 'chrysler', Name: 'Chrysler' },
            { Code: 'citroen', Name: 'Citroen' },
            { Code: 'cobra', Name: 'Cobra' },
            { Code: 'corvette', Name: 'Corvette' },
            { Code: 'd rema', Name: 'D REMA' },
            { Code: 'dac', Name: 'DAC' },
            { Code: 'dacia', Name: 'Dacia' },
            { Code: 'daewoo', Name: 'Daewoo' },
            { Code: 'daf', Name: 'DAF' },
            { Code: 'daihatsu', Name: 'Daihatsu' },
            { Code: 'detomaso', Name: 'DeTomaso' },
            { Code: 'deutz-fahr', Name: 'DEUTZ-FAHR' },
            { Code: 'dodge', Name: 'Dodge' },
            { Code: 'ducati', Name: 'DUCATI' },
            { Code: 'eduards', Name: 'EDUARDS' },
            { Code: 'fendt', Name: 'FENDT' },
            { Code: 'ferrari', Name: 'Ferrari' },
            { Code: 'fiat', Name: 'Fiat' },
            { Code: 'ford', Name: 'Ford' },
            { Code: 'general trailers', Name: 'GENERAL TRAILERS' },
            { Code: 'gmc', Name: 'GMC' },
            { Code: 'gottwald', Name: 'Gottwald' },
            { Code: 'hanomag', Name: 'Hanomag' },
            { Code: 'harley davidson', Name: 'HARLEY DAVIDSON' },
            { Code: 'holden', Name: 'Holden' },
            { Code: 'honda', Name: 'Honda' },
            { Code: 'hover', Name: 'HOVER' },
            { Code: 'humbaur', Name: 'HUMBAUR' },
            { Code: 'hummer', Name: 'Hummer' },
            { Code: 'hyundai', Name: 'Hyundai' },
            { Code: 'infiniti', Name: 'Infiniti' },
            { Code: 'irisbus', Name: 'IRISBUS' },
            { Code: 'isuzu', Name: 'Isuzu' },
            { Code: 'iveco', Name: 'IVECO' },
            { Code: 'jaguar', Name: 'Jaguar' },
            { Code: 'jcb', Name: 'JCB' },
            { Code: 'jdm', Name: 'JDM' },
            { Code: 'jeep', Name: 'Jeep' },
            { Code: 'john deere', Name: 'JOHN DEERE' },
            { Code: 'kangda', Name: 'KANGDA' },
            { Code: 'kawasaki', Name: 'KAWASAKI' },
            { Code: 'kia', Name: 'Kia' },
            { Code: 'koch', Name: 'KOCH' },
            { Code: 'kogel', Name: 'KOGEL' },
            { Code: 'konigsegg', Name: 'Konigsegg' },
            { Code: 'kotschenreuther', Name: 'KOTSCHENREUTHER' },
            { Code: 'kress', Name: 'KRESS' },
            { Code: 'krone', Name: 'KRONE' },
            { Code: 'lada', Name: 'Lada' },
            { Code: 'lamberet', Name: 'LAMBERET' },
            { Code: 'lamborghini', Name: 'Lamborghini' },
            { Code: 'lancia', Name: 'Lancia' },
            { Code: 'land rover', Name: 'Land Rover' },
            { Code: 'landwind', Name: 'Landwind' },
            { Code: 'lexus', Name: 'Lexus' },
            { Code: 'ligier', Name: 'Ligier' },
            { Code: 'Lincoln,lincoln', Name: 'Lincoln' },
            { Code: 'lotus', Name: 'Lotus' },
            { Code: 'mahindra', Name: 'Mahindra' },
            { Code: 'man', Name: 'MAN' },
            { Code: 'maserati', Name: 'Maserati' },
            { Code: 'maybach', Name: 'Maybach' },
            { Code: 'mazda', Name: 'Mazda' },
            { Code: 'mecord', Name: 'MECORD' },
            { Code: 'menci', Name: 'MENCI' },
            { Code: 'mercedes-benz', Name: 'Mercedes-Benz' },
            { Code: 'mg', Name: 'MG' },
            { Code: 'mini', Name: 'Mini' },
            { Code: 'mirsa', Name: 'MIRSA' },
            { Code: 'mitsubishi', Name: 'Mitsubishi' },
            { Code: 'montenegro', Name: 'MONTENEGRO' },
            { Code: 'morgan', Name: 'Morgan' },
            { Code: 'motociclete', Name: 'Motociclete' },
            { Code: 'muller', Name: 'MULLER' },
            { Code: 'new holland', Name: 'NEW HOLLAND' },
            { Code: 'nissan', Name: 'Nissan' },
            { Code: 'nsu', Name: 'NSU' },
            { Code: 'oaf', Name: 'OAF' },
            { Code: 'oldsmobile', Name: 'Oldsmobile' },
            { Code: 'oltcit', Name: 'OLTCIT' },
            { Code: 'opel', Name: 'Opel' },
            { Code: 'padis', Name: 'PADIS' },
            { Code: 'pegaso', Name: 'PEGASO' },
            { Code: 'peischl', Name: 'PEISCHL' },
            { Code: 'peugeot', Name: 'Peugeot' },
            { Code: 'piaggio', Name: 'Piaggio' },
            { Code: 'piggio', Name: 'PIGGIO' },
            { Code: 'plymouth', Name: 'Plymouth' },
            { Code: 'pongratz', Name: 'PONGRATZ' },
            { Code: 'pontiac', Name: 'Pontiac' },
            { Code: 'porsche', Name: 'Porsche' },
            { Code: 'proton', Name: 'Proton' },
            { Code: 'remorci si semiremorci', Name: 'Remorci si semiremorci' },
            { Code: 'renault', Name: 'Renault' },
            { Code: 'rolls royce', Name: 'Rolls Royce' },
            { Code: 'roman', Name: 'ROMAN' },
            { Code: 'rover', Name: 'Rover' },
            { Code: 'saab', Name: 'Saab' },
            { Code: 'samro', Name: 'SAMRO' },
            { Code: 'santana', Name: 'Santana' },
            { Code: 'saris', Name: 'SARIS' },
            { Code: 'scania', Name: 'SCANIA' },
            { Code: 'schmitz', Name: 'SCHMITZ' },
            { Code: 'schwarzmuller', Name: 'SCHWARZMULLER' },
            { Code: 'seat', Name: 'Seat' },
            { Code: 'simpa', Name: 'SIMPA' },
            { Code: 'skoda', Name: 'Skoda' },
            { Code: 'smart', Name: 'Smart' },
            { Code: 'spermann', Name: 'SPERMANN' },
            { Code: 'ssangyong', Name: 'Ssangyong' },
            { Code: 'stema', Name: 'STEMA' },
            { Code: 'steyr', Name: 'STEYR' },
            { Code: 'subaru', Name: 'Subaru' },
            { Code: 'suzuki', Name: 'Suzuki' },
            { Code: 'talbot', Name: 'Talbot' },
            { Code: 'tata', Name: 'Tata' },
            { Code: 'tata motors', Name: 'Tata motors' },
            { Code: 'thule', Name: 'THULE' },
            { Code: 'toyota', Name: 'Toyota' },
            { Code: 'tpv', Name: 'TPV' },
            { Code: 'trabant', Name: 'Trabant' },
            { Code: 'tractor', Name: 'TRACTOR' },
            { Code: 'triumph', Name: 'Triumph' },
            { Code: 'tvr', Name: 'TVR' },
            { Code: 'u445', Name: 'U445' },
            { Code: 'van-hool', Name: 'VAN-HOOL' },
            { Code: 'volkswagen', Name: 'Volkswagen' },
            { Code: 'volvo', Name: 'Volvo' },
            { Code: 'vw', Name: 'VW' },
            { Code: 'wartburg', Name: 'Wartburg' },
            { Code: 'wiesmann', Name: 'Wiesmann' },
            { Code: 'wiola', Name: 'WIOLA' },
            { Code: 'yamaha', Name: 'YAMAHA' }
        ];
    },

    getVehicleBuildYears: function () {
        var result = [];
        var currentYear = new Date().getFullYear(); // 2019; // TODO: Get it from the current date

        for (var i = currentYear; i >= 1920; i--)
            result.push({ Code: i, Name: i + '' });

        return result;
    },

    // Property

    getPropertyTypes: function () {
        return [
            { Code: 0, Name: 'Apartament' },
            { Code: 1, Name: 'Casa' },
            { Code: 2, Name: 'Vila' },
            { Code: 3, Name: 'Apartament in Vila' }
        ];
    },

    getPropertyBuildTypes: function () {
        return [
            { Code: 'BCA', Name: 'BCA' },
            { Code: 'Beton', Name: 'Beton' },
            { Code: 'Beton armat', Name: 'Beton armat' },
            { Code: 'Caramida', Name: 'Caramida' },
            { Code: 'Caramida arsa', Name: 'Caramida arsa' },
            { Code: 'Chirpici sau paianta', Name: 'Chirpici sau paianta' },
            { Code: 'Lemn sau OSB', Name: 'Lemn sau OSB' },
            { Code: 'Mixta(zidarie+lemn)', Name: 'Mixta(zidarie+lemn)' },
            { Code: 'Materiale nesupuse unui tratament termic si/sau chimic', Name: 'Materiale nesupuse unui tratament termic si/sau chimic' },
            { Code: 'Materiale combustibile', Name: 'Materiale combustibile' },
            { Code: 'Piatra', Name: 'Piatra' },
            { Code: 'Structura metalica', Name: 'Structura metalica' },
            { Code: 'Mixta (beton armat+lemn)', Name: 'Mixta (beton armat+lemn)' },
            { Code: 'Mixta (metalica+lemn)', Name: 'Mixta (metalica+lemn)' }
        ];
    },

    getPropertyStructures: function () {
        return [
            { Code: 'Beton armat', Name: 'Beton armat' },
            { Code: 'Metal', Name: 'Metal' },
            { Code: 'Lemn', Name: 'Lemn' }
        ];
    },

    getPropertyFloorSeparations: function () {
        return [
            { Code: 'Beton armat', Name: 'Beton armat' },
            { Code: 'Metal', Name: 'Metal' },
            { Code: 'Lemn', Name: 'Lemn' }
        ];
    },

    getPropertyWalls: function () {
        return [
            { Code: 'Beton armat', Name: 'Beton armat' },
            { Code: 'Metal', Name: 'Metal' },
            { Code: 'Lemn', Name: 'Lemn' },
            { Code: 'Boltari BCA', Name: 'Boltari BCA' },
            { Code: 'Caramida', Name: 'Caramida' },
            { Code: 'Materiale neconventionale', Name: 'Materiale neconventionale' }
        ];
    },

    getPropertyRoofs: function () {
        return [
            { Code: 'terasa', Name: 'Terasa' },
            { Code: 'sarpanta_sau_invelitoare', Name: 'Sarpanta sau invelitoare' }
        ];
    },

    getPropertyRoofStructures: function () {
        return [
            { Code: 'Beton armat', Name: 'Beton armat' },
            { Code: 'Metal', Name: 'Metal' },
            { Code: 'Lemn', Name: 'Lemn' },
            { Code: 'Nu este cazul', Name: 'Nu este cazul' }
        ];
    },

    getPropertyRoofCovers: function () {
        return [
            { Code: 'tigla', Name: 'Tigla' },
            { Code: 'placi_incombustibile', Name: 'Placi incombustibile' },
            { Code: 'tabla', Name: 'Tabla' },
            { Code: 'lemn', Name: 'Lemn' },
            { Code: 'carton_asfalt', Name: 'Carton/Asfalt' },
        ];
    },

    getPropertyBuildYears: function () {
        var result = [];
        var currentYear = new Date().getFullYear();

        for (var i = currentYear; i >= 1940; i--)
            result.push({ Code: i, Name: i + '' });

        return result;
    },

    // Address

    getCounties: function () {
        return axios.get('api/List/counties');
    },

    getTowns: function (countyCode) {
        return axios.get('api/List/towns/' + countyCode);
    },
}

export const listService = listServiceObj;
